import { S3 } from "@aws-sdk/client-s3";

let singletonS3Client: S3 | null = null;

export function getS3(): S3 {
  if (!singletonS3Client) {
    const s3 = new S3({ 
      ...((process.env.NODE_ENV === 'development' || process.env.NODE_ENV === 'test') ? {
        endpoint: process.env.AK_BASE ? process.env.AK_BASE + ':4324' : 'http://127.0.0.1:4323',
        sslEnabled: false,
        forcePathStyle: true,
        credentials: {
          accessKeyId: 'test',
          secretAccessKey: 'testtesttest'
        }
      } : {})
    });
    s3.destroy = () => {console.log('Prevented singleton S3Client from being destroyed');};
    singletonS3Client = s3;
  }
  if (process.env.NODE_ENV === 'development' || process.env.NODE_ENV === 'test') {
    // Setup the necessary buckets lazily
    createLocalBuckets(singletonS3Client).catch(() => {});
  }
    
  return singletonS3Client;
}

export function getCustomS3(endpoint?: string, localUseAWS?: boolean): S3 {
  const s3 = new S3({ 
    ...((!localUseAWS && (process.env.NODE_ENV === 'development' || process.env.NODE_ENV === 'test')) ? {
      endpoint: endpoint || (process.env.AK_BASE ? process.env.AK_BASE + ':4324' : 'http://127.0.0.1:4323'),
      sslEnabled: false,
      forcePathStyle: true,
      credentials: {
        accessKeyId: 'test',
        secretAccessKey: 'testtesttest'
      }
    } : endpoint ? { endpoint } : {})
  });
  if (!localUseAWS && (process.env.NODE_ENV === 'development' || process.env.NODE_ENV === 'test')) {
    // Setup the necessary buckets lazily
    createLocalBuckets(s3).catch(() => {});
  }
    
  return s3;
}

/**
 * For development and testing purposes only, sets up the necessary buckets for dev and CI/CD
 */
export async function getS3Local(): Promise<S3> {
  const s3 = getS3();
  await createLocalBuckets(s3);
  return s3;
}

const createLocalBuckets = async (s3: S3) => {
  if (process.env.NODE_ENV === 'development' || process.env.NODE_ENV === 'test') {
    await Promise.all([
      s3.createBucket({ Bucket: 'aidkit-documents',
        ObjectLockEnabledForBucket: true,
      }).catch(() => {}),
      s3.createBucket({ Bucket: 'aidkit-signatures', ObjectLockEnabledForBucket: true}).catch(() => {}),
      s3.createBucket({ Bucket: 'aidkit-surveys-c285c37', ObjectLockEnabledForBucket: true }).catch(() => {}),
      s3.putBucketVersioning({ Bucket: 'aidkit-surveys-c285c37', VersioningConfiguration: { Status: 'Enabled' } }).catch(() => {}),
      s3.createBucket({ Bucket: 'aidkit-oit-production', ObjectLockEnabledForBucket: false }).catch(() => {}),
      s3.createBucket({ Bucket: 'aidkit-public', ObjectLockEnabledForBucket: false }).catch(() => {}),
      s3.createBucket({ Bucket: 'aidkit-exports', ObjectLockEnabledForBucket: false }).catch(() => {})
    ]);
    // MinIO ignores S3-style ACLs, so set explicit public-read bucket policies
    const publicReadPolicy = (bucket: string) => JSON.stringify({
      Version: '2012-10-17',
      Statement: [{
        Effect: 'Allow',
        Principal: { AWS: ['*'] },
        Action: ['s3:GetObject'],
        Resource: [`arn:aws:s3:::${bucket}/*`]
      }]
    });
    await Promise.all([
      s3.putBucketPolicy({ Bucket: 'aidkit-signatures', Policy: publicReadPolicy('aidkit-signatures') }).catch(() => {}),
      s3.putBucketPolicy({ Bucket: 'aidkit-public', Policy: publicReadPolicy('aidkit-public') }).catch(() => {}),
    ]);
  } else {
    throw Error('This function should only be called in development or test environments');
  }
}
